import React from "react";
import { cn } from "../../utils/lib";

interface LinkProps {
    href?: string;
    text: string;
    className?: string;
    color?: string;
    underline?: boolean;
    target?: "_blank" | "_self" | "_parent" | "_top";
    onClick?: () => void;
    disabled?: boolean;
}

const ViewLink = ({
    href,
    text,
    className = "",
    color = "text-primary",
    underline = true,
    target = "_blank",
    onClick,
    disabled = false,
}: LinkProps) => {
    const baseClasses = cn(
        color,
        !disabled && underline
            ? "underline hover:no-underline"
            : "hover:no-underline",
        "hover:text-opacity-80 transition-colors duration-200 cursor-pointer outline-none focus:outline-none focus:ring-0 font-medium text-xs 2xl:text-sm text-nowrap",
        disabled ? "cursor-not-allowed opacity-50 " : "cursor-pointer",
    );

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.stopPropagation();
        if (disabled) return;
        if (onClick) {
            onClick();
        }
    };

    if (href) {
        return (
            <a
                href={href}
                className={cn(baseClasses, className)}
                target={target}
                rel={target === "_blank" ? "noopener noreferrer" : undefined}
                onClick={handleClick}
            >
                {text}
            </a>
        );
    }

    return (
        <span className={cn(baseClasses, className)} onClick={handleClick}>
            {text}
        </span>
    );
};

export { ViewLink };

